/* Articles de notion : titre « Trois exercices » (mobile) et erreurs en accordéon replié (tous écrans).
   Pages programme et matière : groupes de fiches et matières du hub en accordéon (mobile). */
(function () {
  if (window.__phArt) return; window.__phArt = true;
  var mq = window.matchMedia('(max-width: 700px)');
  var WORDS = ['', 'Un exercice', 'Deux exercices', 'Trois exercices', 'Quatre exercices', 'Cinq exercices', 'Six exercices'];
  function counts() {
    document.querySelectorAll('.ph-dl').forEach(function (sec) {
      if (sec.querySelector('.ph-dl-count')) return;
      var n = sec.querySelectorAll('.ph-dl-ex > li').length, h2 = sec.querySelector('.wrap > h2');
      if (!n || !h2) return;
      var p = document.createElement('p'); p.className = 'ph-dl-count'; p.setAttribute('aria-hidden', 'true');
      p.textContent = WORDS[n] || (n + ' exercices'); h2.parentNode.insertBefore(p, h2);
    });
  }
  function bind(trigger, box) {
    var toggle = function (e) {
      if (!mq.matches) return;
      if (e && e.target && e.target.closest && e.target.closest('a')) e.preventDefault();
      var o = !box.classList.contains('is-open');
      box.classList.toggle('is-open', o); trigger.setAttribute('aria-expanded', o ? 'true' : 'false');
    };
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(e); } });
  }
  function accordions() {
    document.querySelectorAll('.ph-cartes-erreur').forEach(function (sec) {
      sec.classList.add('ph-acc');
      sec.querySelectorAll('.ph-err').forEach(function (card) {
        var h = card.querySelector('h3');
        if (!h || card.getAttribute('data-acc')) return;
        card.setAttribute('data-acc', '1');
        card.classList.remove('is-open');
        h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-expanded', 'false');
        var toggle = function () {
          var o = !card.classList.contains('is-open');
          card.classList.toggle('is-open', o); h.setAttribute('aria-expanded', o ? 'true' : 'false');
        };
        h.addEventListener('click', toggle);
        h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      });
    });
  }
  function mobileAcc() {
    var on = mq.matches;
    function setup(sec, items, getTrigger) {
      sec.classList.toggle('ph-acc', on);
      items.forEach(function (box, i) {
        var t = getTrigger(box); if (!t) return;
        if (!box.getAttribute('data-macc')) { box.setAttribute('data-macc', '1'); box.classList.toggle('is-open', i === 0); bind(t, box); }
        if (on) { t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); t.setAttribute('aria-expanded', box.classList.contains('is-open') ? 'true' : 'false'); }
        else { t.removeAttribute('role'); t.removeAttribute('tabindex'); t.removeAttribute('aria-expanded'); }
      });
    }
    document.querySelectorAll('.ph-fiches').forEach(function (sec) {
      setup(sec, Array.prototype.slice.call(sec.querySelectorAll('.ph-fg')), function (g) { return g.querySelector('.ph-fg-t'); });
    });
    document.querySelectorAll('.ph-programme').forEach(function (sec) {
      setup(sec, Array.prototype.slice.call(sec.querySelectorAll('.ph-col')), function (c) { return c.querySelector('.ph-head'); });
    });
  }
  function init() { counts(); accordions(); mobileAcc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (mq.addEventListener) mq.addEventListener('change', mobileAcc); else if (mq.addListener) mq.addListener(mobileAcc);
  document.addEventListener('shopify:section:load', init);
})();
